<template>
    <select class="option-picker-select"
            v-model="selectedOption"
            @input="event => {selectOption(event.target.value)}">
        <option class="option-picker-option" v-for="(option, name) in options" :value="option" :key="option">
            {{name}}
        </option>
    </select>
</template>

<script>
    export default {
        name: "OptionPicker",
        props: ["options", "value"],
        data() {
            return {
                selectedOption: this.value,
            }
        },
        methods: {
            selectOption(option) {
                this.$emit('input', option)
            }
        }
    }
</script>

<style scoped>
    .option-picker-select {
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
        background-color: white;

        font-size: 15px;
        border: 0;
        cursor: pointer;
        border-radius: 8px;
        margin: 6px 4px;
        padding: 6px 32px 6px 32px;

        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none; /* Remove default arrow */
        white-space: normal;

    }
    option {
        color: red;
    }
</style>